<template>
    <div id="vertical-gallery">
        <!-- <div class="close-btn" @click="$emit('close')">X</div> -->
            
        <div v-for="image in images" :key="image.id">
            <img :src="'img/pastor/' + image.name" class="img-fluid my-2" >
        </div>
    
    </div>   
</template>

<script>
export default {
  props: ["images"],
  mounted() {
    document.addEventListener("backbutton", this.closeMethod, false);
  },
  beforeDestroy() {
    document.removeEventListener("backbutton", this.closeMethod);
  },
  methods: {
    closeMethod() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="css" scoped>
#vertical-gallery {
  background: rgba(250, 250, 250, 0.8);
  backdrop-filter: blur(10px);
  padding: 1rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  color: #fff;
  overflow-y: auto;
}
</style>